import { Box, Typography } from "@mui/material";
import React, { createContext, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import NavigationRailIcons from "../common-components/NavigationRailIcons";
import LoadingModal from "../common-components/LoadingModal";
import MessagePopup from "../popup-components/MessagePopup";

export const LoadingModalContext = createContext({
  setLoadingState: () => { },
});
export const MessagePopupContext = createContext(null);

const ServicePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [isNavOpen, setIsNavOpen] = useState(false); // Track menu state
  const [message, setMessage] = useState("");
  const [messagePopup, setMessagePopup] = useState(false);
  const [loadingState, setLoadingState] = useState({
    open: false,
    message: "Getting you a quality response...",
    progress: null,
  });


  // Handler for the "Okay" button in the message popup
  const okayHandler = () => {
    setMessagePopup(false);
    setMessage("");

    // Navigate to home if the message indicates session expiration
    if (message === "Your session has expired.") {
      navigate("/");
    }
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        backgroundColor: "#f6f3f2",
      }}
    >
      {/* Navigation Sidebar */}
      <Box
        sx={{
          width: isNavOpen ? "220px" : "80px", // Adjust width dynamically
          transition: "width 0.3s ease-in-out",
        }}
      >
        <NavigationRailIcons setIsNavOpen={setIsNavOpen} />
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flexBasis: `calc(100% - ${isNavOpen ? "220px" : "80px"})`,
          height: "100%",
          overflow: "hidden",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#f6f3f2",
            padding: "18px",
            zIndex: 999,
            transition: "margin-left 0.3s ease-in-out",
            marginLeft: isNavOpen ? "4px" : "0px", // Moves text when nav expands
          }}
        >
          <Typography
            sx={{ fontSize: "14px", lineHeight: "20px", marginTop: "17px" }}
          >
            QMentisAI™ - Intelligence for Next-Gen Quality
          </Typography>
        </Box>

        {/* Main Content Area */}
        <Box
          sx={{
            height: "100%",
            overflow: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <LoadingModalContext.Provider value={{setLoadingState}}>
            <MessagePopupContext.Provider
              value={{ setMessage, setMessagePopup }}
            >
              {/* Render the nested routes */}
              <Outlet />
            </MessagePopupContext.Provider>
          </LoadingModalContext.Provider>
        </Box>
      </Box>

      {/* Loading Modal */}
      <LoadingModal
        open={loadingState.open}
        message={loadingState.message}
        progress={loadingState.progress}
      />


      <MessagePopup modalOpen={messagePopup} message={message} okayHandler={okayHandler} />
    </Box>
  );
};

export default ServicePage;